import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { PostbackGoalActions } from './PostbackGoalActions';
import { actions } from './PostbackGoalActions.actions';
import {
    getOffers,
    getGoalActions,
    getGoals,
    getGoalActionIds
} from './PostbackGoalActions.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    offers: getOffers,
    goalActions: getGoalActions,
    goals: getGoals,
    goalActionIds: getGoalActionIds,
});

const PostbackGoalActionsComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.goalActions.loading,
            loadingGoals: state.goals.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getGoalActions: actions.getGoalActions,
            getListCurGoals: actions.getListCurGoals
        };
    }
)(PostbackGoalActions);

export default PostbackGoalActionsComponent;
